/* original file: src\assets\js\google-analytics-init.js */
(function () {
    if (window['__config__']?.environmentName !== 'prod') return;

    // Load google gtag script
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-EVQQLXSL5E';

    // Initiate google analytics
    gtagScript.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        gtag('js', new Date());

        gtag('config', 'G-EVQQLXSL5E'); // cspell:words G-EVQQLXSL5E
    };

    document.head.appendChild(gtagScript);
})();
